<div style="position: relative; z-index: 10;">
  <div>
    <!-- contenedor de todo el header -->
    <div class="containerNavBar" [class.example-is-mobile]="!mobileQuery.matches">
    <loading [isFixed]="true" [isLoading]="this.isLoading" [isFullSize]="true"></loading>

    <!-- poner *ngIf="isMapix" para que no se muestre en citronella el nav -->
      <mat-toolbar class="fullNav"  id="fullNav" *ngIf="isMapix">

          <!-- boton para abrir side-bar -->
        <div style="width: 55px;">
          <button *ngIf="!mobileQuery.matches" mat-icon-button (click)="EnlargeOrCloseSideBar()" id="sideBarButtonNav">
            <img
              src="/assets/img/navBar/btn_menu_blanco.png"
              style="width: 1.5em;"
            />
          </button>
        </div>

        <!-- titulo de la aplicacion y datos del usuario-->
        <div class="nav-text">
          <div class="nav-text-left">
            <div class="nav-text-appname">
              <img
              src="/assets/img/logo mapix v4 blanco.png"
              style="width: 8.5em;"
            />
              <!-- <p class="title"><span>Geointeligent</span></p> -->
            </div>
          </div>

          <!-- datos del cliente -->
          <div class="nav-text-right">

            <!-- select -->
             <div [ngClass]="{'display-none': !mobileQuery.matches}" class="nav-text-client" id="customerSelectNav">
              <mat-select class="form-control btn-clients"
                [placeholder]="clienteDisplay"
                [(value)]="clienteDisplay"
                (selectionChange)="onChangeClient($event)"
                [disabled]=" !isMapix "
                *ngIf="isMapix">
                  <mat-option *ngFor="let client of clientes" [value]="client.idCustomer">
                    {{ client.customerName }}
                  </mat-option>
              </mat-select>
            </div>

            <!-- seccion de notificacion -->
            <div class="nav-notification" id="notificationsButtonNav" style="display: none;">
              <button (click)="toggleNotifications()" class="tool-button nav-notification-button" matTooltip="Notificaciones">
                <img class="toolImg nav-notification-img" [src]="'icon_notificacion_rojo.svg' | findUrl"   /> 
                <span class="badge" *ngIf="this.notificationService.navNotificationCount > 0">{{ this.notificationService.navNotificationCount }}</span>
              </button>
              <app-nav-notifications></app-nav-notifications>
            </div> 
                
            <!-- alarmas 
            <div class="nav-notification" id="alarmsButtonNav">
              <button (click)="ToggleAlarms()" class="tool-button">
                <img class="toolImg" [src]="'icon_alarmas_blanco.svg' | findUrl"   />
              </button>
            </div> -->

            <div class="nav-notification" id="tutorialResetButton">
              <button (click)="ResetTutorials()" class="tool-button" matTooltip="Reiniciar Tutoriales">
                <mat-icon>help_outline</mat-icon>
              </button>
            </div>
            <!-- usuario y rol -->
            <div [ngClass]="{'display-none': !mobileQuery.matches}" class="nav-text-user">
              <div class="user-section">
                <div class="col-3 userImg-container">
                  <img class="userImg" [src]="'icon_perfil_blnaco.svg' | findUrl"  /> 
                </div>    
                <div class="col-9 user-info">
                  <span class="rowUserName">{{rolItem}}</span>
                  <span *ngIf="isMapix" class="rowEmail">{{userName}}</span>
                </div>
              </div>
            </div>

          </div>

            <!-- boton de cerrar sesion -->
            <!--<span class="version">v3.1</span>-->
            <button *ngIf="isMapix" mat-button (click)="Logout()" class="btnLogout">
              Cerrar Sesión
            </button>
        </div>
        
      </mat-toolbar>

      <!-- contenedor del Side-bar -->
      <mat-sidenav-container
        class="example-container enlargeSideBar"
        [style.marginTop.px]="mobileQuery.matches ? 70 : 58"
        [ngClass]="{'enlargeSideBar': this.isEnlargedSideBar}">

        <!-- contenido del side bar -->
        <mat-sidenav
          #snav
          [mode]="mobileQuery.matches ? 'over' : 'side'"
          [fixedInViewport]="true"
          [style.marginTop.px]="mobileQuery.matches ? 55 : 56"
          [opened]="mobileQuery.matches"
          disableClose="true"
          class="menu-sidenav"
          id="sideBarNav"
          (mouseleave)="CloseSideBar($event)"
          (mouseenter)="StopCloseTimeout()">
          <!-- solo se crea cuando cargan las views -->
          <ng-container *ngIf="views">

            <mat-nav-list class="items-menu">

              <div class="nav-button-section"  [ngClass]="{'nav-button-section-enlarged': isEnlargedSideBar}">
                <button class="nav-button" *ngIf="mobileQuery.matches" mat-icon-button (click)="EnlargeOrCloseSideBar()" id="sideBarButtonNav">
                  <img
                    src="../../../../assets/img/navBar/btn_menu_azul.png"
                    style="width: 1.5em;"
                  />
                </button>
              </div>

              <!-- Sección superior con imagen de usuario y textos -->
              <div class="profile-section">
                <img src="../../../../assets/img/navBar/icon_perfil.png" alt="Usuario" matTooltip="Perfil de Usuario" class="profile-image" style="height: 50px" (click)="EnlargeOrCloseSideBar()"/>
                <div class="profile-text">
                  <label *ngIf="isMapix" class="font-weight-bold">{{userName}}</label>
                  <label>{{rolItem}}</label>
                  <label *ngIf="clientes.length < 2 && isMapix">{{ clienteDisplay }}</label>
                  <div class="nav-text-client" *ngIf="clientes.length > 1 && !this.mobileQuery.matches">
                    <mat-select class="form-control btn-clients"
                      [placeholder]="clienteDisplay"
                      [(value)]="clienteDisplay"
                      (selectionChange)="onChangeClient($event)"
                      [disabled]=" !isMapix ">
                        <mat-option *ngFor="let client of clientes" [value]="client.idCustomer">
                          {{ client.customerName }}
                        </mat-option>
                    </mat-select>
                  </div>
                </div>
              </div>

              <mat-divider></mat-divider>

              <!-- Sección inferior con opciones del navbar -->
              <div class="menu-options">
                <!-- views dinamicas excepto la de config -->
                <ng-container *ngFor="let view of views">
                  <div
                    id="{{view.name}}"
                    class="navbar-option" matTooltip="{{view.name}}"
                    *ngIf="view.name | permissionFilter"
                    [disabled]="isBlocked"
                    (click)="onClickMenuButton(view.uri)">
                    <img [src]="'../../../../assets/img/navBar/' + view.icon" alt="" />
                    <span>{{ view.name }}</span>
                  </div>
                </ng-container>
                <!-- solo view de config, para que aparezca al final -->
                <!-- <div
                  id="Configuración" matTooltip="Configuración"
                  *ngIf="('Configuración' | permissionFilter)"
                  class="navbar-option"
                  (click)="onClickMenuButton('dashboardAdmin')">
                  <img [src]="'icon_configuration.png' | findUrl" alt="" [ngClass]="{'dashboardAdminImHere': router.url === '/dashboardAdmin'}" />
                  <span>Configuración</span>
                </div> -->
                <!-- <div
                  id="Centro de Descargas" matTooltip="Centro de Descargas"
                  *ngIf="true || ('Centro de Descargas' | permissionFilter)"
                  class="navbar-option"
                  (click)="onClickMenuButton('downloads')">
                  <img [src]="'icon_configuration.png' | findUrl" alt="" [ngClass]="{'dashboardAdminImHere': router.url === '/downloads'}" />
                  <span>Centro de Descargas</span>
                </div> -->
                <!-- <div
                  id="mainDashboard" matTooltip="dashboard"
                  *ngIf="true || ('Main Dashboard' | permissionFilter)"
                  class="navbar-option"
                  (click)="onClickMenuButton('mainDashboard')">
                  <img [src]="'icon_configuration.png' | findUrl" alt="" [ngClass]="{'dashboardAdminImHere': router.url === '/mainDashboard'}" />
                  <span>Main Dashboard</span>
                </div> -->
                <div
                  id="Configuración" matTooltip="Configuración"
                  *ngIf="('Configuración' | permissionFilter)"
                  class="navbar-option"
                  (click)="onClickMenuButton('settingsAdmin')">
                  <img [src]="'icon_configuration.png' | findUrl" alt="" [ngClass]="{'dashboardAdminImHere': router.url === '/dashboardAdmin'}" />
                  <span>Configuración</span>
                </div>
              </div>

            </mat-nav-list>

          </ng-container>
        </mat-sidenav>
      </mat-sidenav-container>

    </div>
  </div>
</div>
